
import React from 'react';
import { makeStyles } from "diginet-core-ui/theme";
import GoogleMapReact from 'google-map-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Config from '../../../config';

const Wrapper = styled.main`
  width: 100%;
  height: 100%;
`;

const GoogleMap = ({ children, ...props }) => (
    <Wrapper>
        <GoogleMapReact
            bootstrapURLKeys={{
                key: Config.getSetting("GOOGLE_MAPS_PLATFORM_KEY")
            }}
            {...props}
        >
            {children}
        </GoogleMapReact>
    </Wrapper>
);


const cssSize = new Map([
    ['marker', {
        sm: {
            width: 40,
            height: 40,
            transform: 'translate(-20px, -60px)',
        },
        md: {
            width: 60,
            height: 60,
            transform: 'translate(-30px, -80px)',
        }
    }],
    ['markerAfter', {
        sm: {
            bottom: '-20px',
            borderLeft: `20px solid transparent`,
            borderRight: `20px solid transparent`,
        },
        md: {
            bottom: '-27px',
            borderLeft: `25px solid transparent`,
            borderRight: `25px solid transparent`,
        }
    }],
    ['innerCircle', {
        sm: {
            top: 8,
            left: 8,
            width: 24,
            height: 24,
        },
        md: {
            top: 12,
            left: 12,
            width: 36,
            height: 36,
        }
    }],
]);

const arrClassName = Object.keys(Object.fromEntries(cssSize));

const PlaceIcon = (props) => {
    const { size } = props;
    const useStyles = makeStyles((theme) => {
        const customMarker = cssSize.get(arrClassName?.[0])?.[size];
        const customMarkerAfter = cssSize.get(arrClassName?.[1])?.[size];
        const customInnerCircle = cssSize.get(arrClassName?.[2])?.[size];
        const { colors = {} } = theme || {};
        return ({
            marker: {
                position: 'relative',
                backgroundColor: colors?.success6,
                borderRadius: '50%',
                ...customMarker,
                '&:after': {
                    content: "''",
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 0,
                    height: 0,
                    borderTop: `${size === 'md' ? 40 : 32}px solid ${colors?.success6}`,
                    ...customMarkerAfter,
                }
            },
            innerCircle: {
                position: 'absolute',
                backgroundColor: colors?.warning1,
                borderRadius: '50%',
                zIndex: 100,
                ...customInnerCircle,
            }
        })
    });

    const classes = useStyles();

    return (
        <div className={classes.marker}>
            <div className={classes.innerCircle}></div>
        </div>
    )
};

PlaceIcon.propTypes = {
    size: PropTypes.oneOf(['small', 'medium']), //sm 40 md 60 lg 80
};

PlaceIcon.defaultProps = {
    size: 'sm'
};

GoogleMap.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node),
    ]),
};

GoogleMap.defaultProps = {
    children: null,
};

export { GoogleMap, PlaceIcon };

